import dayjs from 'dayjs';
import { FORMAT_DATE } from '../uiKit/utils';

export const formatStringRuToDate = (date: string): Date => dayjs(date, 'DD.MM.YYYY').toDate();
export const formatStringToDateRu = (date: string): Date => dayjs(date, 'DD.MM.YYYY').toDate();
export const formatDateToStringRu = (date: Date): string => dayjs(date).format(FORMAT_DATE);
